<template>
  <div>
    <h3 class="mb-4" v-if="getUser && getUser.client">Klijent: {{getUser.client.name}}</h3>
    <b-row>
      <b-col class="col-xxl-6">
        <b-card>
          <div class="d-flex justify-content-between" >
            <div class="d-flex flex-column justify-content-between">
              <div class="header-1">{{dashboard.nviDate | formatDate}}</div>
              <div class="header-2">Ukupno stanje na dan</div>
            </div>
            <i class="fa fa-calendar fa-fw large-icon" aria-hidden="true"></i>
          </div>
        </b-card>
      </b-col>
      <b-col class="col-xxl-6">
        <b-card>
          <div class="d-flex justify-content-between" >
            <div class="d-flex flex-column justify-content-between">
              <div class="header-1">{{ dashboard.sumQuota| formatDecimals(6)}}</div>
              <div class="header-2">Broj udjela u vlasništvu</div>
            </div>
            <i class="fa fa-pie-chart  fa-fw large-icon" aria-hidden="true"></i>
          </div>
        </b-card>
      </b-col>
      <b-col class="col-xxl-6">
        <b-card>
          <div class="d-flex justify-content-between" >
            <div class="d-flex flex-column justify-content-between">
              <div class="header-1">{{ dashboard.nviValue | formatDecimals(4) }} (KM)</div>
              <div class="header-2">Vrijednost jednog udjela</div>
            </div>
            <i class="fa fa-sort fa-fw large-icon" aria-hidden="true"></i>
          </div>
        </b-card>
      </b-col>
      <b-col class="col-xxl-6">
        <b-card>
          <div class="d-flex justify-content-between" >
            <div class="d-flex flex-column justify-content-between">
              <div class="header-1">{{ dashboard.sum | formatDecimals(2) }} (KM)</div>
              <div class="header-2">Ukupna vrijednost udjela u vlasništvu</div>
            </div>
            <i class="fa fa-line-chart fa-fw large-icon" aria-hidden="true"></i>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="col-xxl-3">
        <b-card>
          <div class="d-flex justify-content-between" >
            <div class="d-flex flex-column justify-content-between">
              <div class="header-1">{{ dashboard.enterAmount | formatDecimals(2)}} (KM)</div>
              <div class="header-2">Ukupno uplaćeno</div>
            </div>
            <i class="fa fa-plus-square  fa-fw large-icon" aria-hidden="true"></i>
          </div>
        </b-card>
      </b-col>
      <b-col class="col-xxl-3">
        <b-card>
          <div class="d-flex justify-content-between" >
            <div class="d-flex flex-column justify-content-between">
              <div class="header-1">{{ dashboard.outputAmount | formatDecimals(2)}} (KM)</div>
              <div class="header-2">Ukupno isplaćeno</div>
              <span style="font-family: auto;">* umanjeno za izlaznu naknadu</span>
            </div>
            <i class="fa fa-minus-square fa-fw large-icon" aria-hidden="true"></i>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {getDashboardData} from "@/services/client";
import {USER_DATA} from "@/shared/constants";
import {mapGetters} from "vuex";
import {formatDate, formatDecimals} from "@/filters/formatDates";
import {toast} from "@/shared/plugins/toastr";
import {getErrorMessage} from "@/mixins/error/getErrorMessage";

export default {
  name: 'ClientDashboard',
  mixins: [getErrorMessage],
  data() {
    return {
      dashboard: {
        nviDate: null,
        nviValue: null,
        sumQuota: null,
        outputAmount: null,
        enterAmount: null,
        sum: null
      }
    }
  },
  filters: {
    formatDate, formatDecimals
  },
  computed: {
    ...mapGetters('client', ['client']),
    ...mapGetters('user', ['getUser']),
    user(){
      return JSON.parse(localStorage.getItem(USER_DATA))
    }
  },
  watch: {
    'client.id': {
        async handler(value) {
          if(value) {
            await getDashboardData({client_id: value}).then((response) => {
              this.dashboard = response.data
            },(error) => {
              toast({
                'title': "Greška",
                'message': this.getMessages(error),
                'type': 'error',
                'timeout': 6000
              })
            })
          }

        },
      immediate: true
    },
  },
};
</script>

<style scoped>
.large-icon {
  font-size: 46px;
  line-height: 1.2;
  color: #e94f4f;
  height: 93px;
}
</style>
